/* jshint esnext: true */
import { APP_NAME, $html, $document } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'VideoModal';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`,
    OPEN: `open.${EVENT_NAMESPACE}`,
    KEYUP: `keyup.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.inner = this.$el.find('.js-video-modal-inner')[0];
        this.$close = this.$el.find('.js-video-modal-close');
    }

    init() {
        $document.on(EVENT.OPEN, (e) => {
            this.show(e);
        })

        this.$close.on(EVENT.CLICK, this.hide.bind(this));

        $document.on(EVENT.KEYUP, (e) => {
            if(e.keyCode === 27) {
                this.hide();
            }
        })
    }

    show(e) {
        if(this.emptyTimeout) clearTimeout(this.emptyTimeout);

        const { id, platform } = e.options;

        this.appendDelay = setTimeout(() => {
            switch(platform) {
                case 'youtube':
                    this.videoUrl = `https://www.youtube.com/embed/${id}?&autoplay=1`
                    this.inner.innerHTML = `<iframe src="https://www.youtube.com/embed/${id}?&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
                    break;
                case 'vimeo':
                    this.videoUrl = `https://player.vimeo.com/video/${id}?autoplay=1&loop=1&autopause=0`
                    this.inner.innerHTML = `<iframe src="https://player.vimeo.com/video/${id}?autoplay=1&autopause=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`
                    break;
                default:
                    break;
            }
        }, 500);

        this.el.classList.add('is-active');
    }

    hide() {
        clearTimeout(this.appendDelay)

        this.el.classList.remove('is-active');

        this.emptyTimeout = setTimeout(() => {
            this.inner.innerHTML = '';
        }, 250);
    }

    destroy() {
        super.destroy();

        $document.off(`.${EVENT_NAMESPACE}`);
        this.$el.off(`.${EVENT_NAMESPACE}`);
        this.$close.off(`.${EVENT_NAMESPACE}`);
    }
}
